import React, { useState, useEffect } from "react";
import calendar from "../../assets/images/calendar.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import stylesTab from "./Report.module.scss";
import { Icon } from "../../assets/Icons.tsx";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { useDispatch } from "react-redux";
import { investorConferenceData } from "../../redux/slices/investorSlice.js";
import styles from "./FinanceTable.module.scss";

const ConferenceTable: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isYearPickerOpen, setIsYearPickerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Q1");
  const [reportData, setReportData] = useState([]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Q1":
        return (
          <div>
            <TableData
              financialYear={financialYear}
              cardData={reportData?.[0]?.sub_tab_details?.contents || []}
            />
          </div>
        );
      case "Q2":
        return (
          <div className="row">
            <div className="col-12">
              <TableData
                financialYear={financialYear}
                cardData={reportData?.[1]?.sub_tab_details?.contents || []}
              />
            </div>
          </div>
        );
      case "Q3":
        return (
          <div className="row">
            <div className="col-12">
              <TableData
                financialYear={financialYear}
                cardData={reportData?.[2]?.sub_tab_details?.contents || []}
              />
            </div>
          </div>
        );
      case "Q4":
        return (
          <div>
            <TableData
              financialYear={financialYear}
              cardData={reportData?.[3]?.sub_tab_details?.contents || []}
            />
          </div>
        );

      default:
        return <div>No Content</div>;
    }
  };

  const calculateFinancialYear = (year) => {
    return `FY ${year}`;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFinancialYear(calculateFinancialYear(date));
    setIsYearPickerOpen(false);

    setIsCalendarOpen(false);
  };

  const breadcrumb = [
    { title: "Investors", link: "/investors" },
    { title: "Results and Reports", link: "" },
  ];
  const startYear = 2009;
  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
    years.push(`${year}-${year + 1}`);
  }
  const [selectedYear, setSelectedYear] = useState(years[0]);
  const [financialYear, setFinancialYear] = useState(selectedYear);

  const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedYear(event.target.value);
    setFinancialYear(event.target.value);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchConferenceData = async () => {
      try {
        const data = await dispatch(
          investorConferenceData(selectedYear),
        ).unwrap();
        console.log(data, "ytyyy");
        setReportData(data?.conference_details?.[0]?.tab_details?.contents);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      }
    };
    fetchConferenceData();
  }, [dispatch, selectedYear]);

  return (
    <div className={stylesTab.ReportsSection}>
      <BreadCrumb menu={breadcrumb} />

      <div className="container">
        <div className={stylesTab.bannerText}>
          <div className="row mt-5">
            <div className="col-lg-12 col-sm-12 col-md-12">
              <p className="heading">Conference Call Recording & Transcript </p>
              <p className="para">
                See Aptech's Quarterly & Conference Call Recording & Transcript
                . 
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="section">
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex flex-column justify-content-center align-items-center">
              <div
                className="p-2 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "black",
                  height: "50px",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
              >
                <img
                  src={calendar}
                  alt="calendar"
                  style={{ height: "25px", width: "25px" }}
                />
                <span
                  className="para mb-0"
                  style={{ color: "white", paddingLeft: "5px" }}
                >
                  Financial Year |
                </span>
                <div className={stylesTab.customSelect}>
                  <select
                    value={selectedYear}
                    onChange={handleYearChange}
                    className={`para mb-0 ${stylesTab.textPadding}`}
                  >
                    {years?.map((year) => (
                      <option key={year} value={year}>
                        <span style={{ color: "white" }}>FY {year}</span>
                      </option>
                    ))}
                  </select>
                  <div className={stylesTab.customIcon}>
                    <Icon
                      name="dropDownArrow"
                      width="30px"
                      height="50px"
                      color="white"
                      strokeWidth="1"
                    />
                  </div>
                </div>
              </div>

              {isCalendarOpen && (
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  inline
                />
              )}

              {isYearPickerOpen && (
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  showYearPicker
                  dateFormat="yyyy"
                  inline
                />
              )}
            </div>
          </div>
        </div>

        <div className="row g-0">
          <div className="col-12 d-flex flex-column justify-content-center">
            {reportData?.length > 0 && (
              <div className="d-flex justify-content-center">
                <ul
                  className={`nav nav-pills ${stylesTab.navPills} d-flex overflow-auto`}
                  id="pills-tab"
                  role="tablist"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {reportData?.map((tab) => (
                    <li
                      key={tab?.sub_tab_details?.name}
                      className="nav-item me-3 flex-shrink-0"
                      role="presentation"
                    >
                      <button
                        className={`${stylesTab.navLink} ${
                          activeTab === tab?.sub_tab_details?.name
                            ? stylesTab.navLinkActive
                            : ""
                        }`}
                        onClick={() =>
                          handleTabClick(tab?.sub_tab_details?.name)
                        }
                        type="button"
                        role="tab"
                        aria-controls={`pills-${tab?.sub_tab_details?.name.toLowerCase()}`}
                        aria-selected={activeTab === tab?.sub_tab_details?.name}
                      >
                        {tab?.sub_tab_details?.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="container">
              <div className="tab-content w-100" id="pills-tabContent">
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConferenceTable;

export const TableData = ({ financialYear, cardData }) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 992);
    };

    updateView();
    window.addEventListener("resize", updateView);

    return () => window.removeEventListener("resize", updateView);
  }, []);
  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  return (
    <div id="FinanceTable" className={`${styles.FinanceTable} mt-4`}>
      {!isMobile && (
        <>
          <div className={`row g-0 ${styles.header}`}>
            <div className="col-3 d-flex justify-content-start align-items-center">
              <p className="para caps fw-bold mb-0">financial year (FY)</p>
            </div>
            <div className="col-7 d-flex justify-content-start align-items-center">
              <p className="para caps fw-bold mb-0">Title</p>
            </div>
            <div className="col-1 d-flex justify-content-center align-items-center">
              <p className="para caps fw-bold mb-0">View</p>
            </div>
            <div className="col-1 d-flex justify-content-center align-items-center">
              <p className="para caps fw-bold mb-0">Download</p>
            </div>
          </div>

          <div className="mb-3">
            {cardData?.map((card, index) => (
              <div
                className={`row g-0 ${styles.brandCard} mt-2 align-items-stretch`}
                key={index}
              >
                <div className="col-3 d-flex justify-content-start align-items-center">
                  <p className="para caps mb-0">FY-{financialYear}</p>
                </div>
                <div className="col-7 d-flex justify-content-start align-items-center">
                  {card?.file_type === "pdf" && (
                    <Icon name="pdfIcon" width="20px" />
                  )}
                  {card?.file_type === "mp4" && (
                    <Icon name="videoCall" width="20px" />
                  )}
                  {(card?.file_type === "mp3" || card?.file_type === "m4a") && (
                    <Icon name="audioIcon" width="20px" />
                  )}
                  <p className={`para mb-0 ${styles.titleStyle}`}>
                    {card?.file_title}
                  </p>
                </div>

                <div className="col-1 d-flex justify-content-center align-items-center">
                  <div style={{ cursor: "pointer" }}>
                    <a
                      href={card?.file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {card?.file_type === "pdf" ? (
                        <Icon
                          name="eyeIcon"
                          color="#036995"
                          height="35px"
                          width="35px"
                        />
                      ) : (
                        <Icon
                          name="speakerIcon"
                          color="#036995"
                          height="38px"
                          width="38px"
                        />
                      )}
                    </a>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-center align-items-center">
                  {card?.file_type === "pdf" ? (
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        downloadFile(card.file_path, card.file_name)
                      }
                    >
                      <Icon
                        name="circleDownArrow"
                        color="#036995"
                        height="35px"
                        width="35px"
                      />
                    </span>
                  ) : ["mp3", "m4a", "mp4"].includes(card?.file_type) ? (
                    <Icon
                      name="dashIcon"
                      color="#036995"
                      height="18px"
                      width="15px"
                    />
                  ) : null}
                </div>
              </div>
            ))}
            {cardData?.length === 0 && (
              <div className={`${styles.brandCard} p-0 mt-2`}>
                <p className="subHeading text-center caps mt-4 mb-4">
                  No Data available
                </p>
              </div>
            )}
          </div>
        </>
      )}
      {isMobile && (
        <div className="mb-3">
          {cardData?.map((card, index) => (
            <div
              className={`${styles.brandCard} mt-2 align-items-stretch`}
              key={index}
            >
              <div
                style={{
                  height: "10px",
                  backgroundColor: "#E1C78C",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                }}
              ></div>
              <div className="p-3">
                <div>
                  <p className={`para mb-0`}>
                    <strong className="text-uppercase">
                      financial year (FY):
                    </strong>{" "}
                    {financialYear} {card.year}
                  </p>
                  <p className={`para mb-0 pt-2`} style={{ textAlign: "left" }}>
                    <strong className="text-uppercase">Title:</strong>{" "}
                    {card?.file_type === "pdf" && (
                      <Icon name="pdfIcon" width="20px" />
                    )}
                    {card?.file_type === "mp4" && (
                      <Icon name="videoCall" width="20px" />
                    )}
                    {(card?.file_type === "mp3" ||
                      card?.file_type === "m4a") && (
                      <Icon name="audioIcon" width="20px" />
                    )}{" "}
                    <span className={styles.titleStyle}>{card.file_title}</span>
                  </p>
                </div>

                <div className="d-flex justify-content-end pt-4">
                  <div>
                    <a
                      href={card?.file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {card?.file_type === "pdf" ? (
                        <Icon
                          name="eyeIcon"
                          color="#036995"
                          height="35px"
                          width="35px"
                        />
                      ) : ["mp3", "m4a", "mp4"].includes(card?.file_type) ? (
                        <Icon
                          name="speakerIcon"
                          color="#036995"
                          height="38px"
                          width="38px"
                        />
                      ) : null}
                    </a>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ paddingLeft: "15px" }}
                  >
                    {card.file_type === "pdf" && (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          downloadFile(card.file_path, card.file_name)
                        }
                      >
                        <Icon
                          name="circleDownArrow"
                          color="#036995"
                          height="35px"
                          width="35px"
                        />
                      </span>
                    )}
                    {["mp3", "m4a", "mp4"].includes(card?.file_type) && (
                      <Icon
                        name="dashIcon"
                        color="#036995"
                        height="18px"
                        width="25px"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
          {cardData?.length === 0 && (
            <div className={`${styles.brandCard} p-0 mt-2`}>
              <p className="subHeading text-center caps mt-4 mb-4">
                No Data available
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
